import Auth from '../../../api/Auth';
import * as types from './mutation-types';
import User from "../../../api/User";

export const register = async ({ dispatch, commit }, payload) => {
    const json = await new Auth().register(payload);

    commit(types.LOGIN, {
        token: json.token,
    });

    await dispatch('getUserCurrent');
};

export const login = async ({ dispatch, commit }, payload) => {
    const json = await new Auth().login(payload);

    commit(types.LOGIN, {
        token: json.token,
    });

    dispatch('getUserCurrent');
};

export const logout = async ({ commit }) => {
    commit(types.ID, null);
    commit(types.NAME, null);
    commit(types.USERNAME, null);
    commit(types.EMAIL, null);
    commit(types.ROLE_ID, null);
    commit(types.IMAGE, null);
    commit(types.CREATED_AT, null);
    commit(types.UPDATED_AT, null);
    commit(types.LOGOUT);
};

export const changeLanguage = async (context, payload) => new Auth().changeLanguage(payload);

export const passwordEmail = async (context, payload) => new Auth().passwordEmail(payload);

export const resetPassword = async (context, payload) => new Auth().resetPassword(payload);

export const setImage = async (context, payload) => new Auth().setImage(payload);

export const getUserCurrent = async ({ dispatch, commit }) => {
    try {
        const json = await new Auth().getCurrent();

        commit(types.ID, json.data.id);
        commit(types.NAME, json.data.name);
        commit(types.USERNAME, json.data.username);
        commit(types.EMAIL, json.data.email);
        commit(types.ROLE_ID, json.data.role_id);
        commit(types.IMAGE, json.data.image);

        if (json.data.default_language !== null && json.data.default_direction !== null) {
            commit(types.DEFAULT_DIRECTION, json.data.default_direction);
            commit(types.DEFAULT_LANGUAGE, json.data.default_language);
        } else if (json.data.school !== null
            && json.data.school.default_direction !== null
            && json.data.school.default_language !== null) {
            commit(types.DEFAULT_DIRECTION, json.data.school.default_direction);
            commit(types.DEFAULT_LANGUAGE, json.data.school.default_language);
        }

        commit(types.CREATED_AT, json.data.created_at);
        commit(types.UPDATED_AT, json.data.updated_at);
    } catch (e) {
        await dispatch('logout');
    }
};

export const checkLogged = async ({ dispatch, commit }) => {
    const token = window.getAppStorage('token');

    if (token) {
        commit(types.LOGIN, {
            token,
        });

        await dispatch('getUserCurrent');
    }
};

export const dashboardInfo = async ({ commit }) => {
    const json = await new Auth().dashboardInfo();

    commit(types.LESSON_DASHBOARD, json);

    commit(types.CERTIFICATES,
        json.certificates.map(certificate => (
            {
                ...certificate,
                isShow: false,
            }
        ))
    );

    commit(types.BADGES,
        json.badges.map(badge => (
            {
                ...badge,
                isShow: false,
            }
        ))
    );
};

export default {
    login,
    logout,
    register,
    passwordEmail,
    resetPassword,
    getUserCurrent,
    checkLogged,
    changeLanguage,
    setImage,
    dashboardInfo,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js